import css from 'styled-jsx/css';
import { colors, spacing, zIndex } from '../../../config/styles';

const MordenImageGalleryStyles = css`
  /* Block: Modern Image Gallery */
  .modern-image-gallery {
    display: flex;
    gap: ${spacing.sm};
    align-items: flex-start;
    max-width: 100%;
    margin-bottom: 16px;
    width: 100%;
  }

  /* Element: Carousel container */
  .modern-image-gallery__carousel {
    flex-shrink: 0;
  }

  /* Element: Headline container */
  .modern-image-gallery__headline {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 665px;
    border: 1px solid ${colors.white.shade4};
  }

  /* Element: Controls container */
  .modern-image-gallery__controls {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${zIndex.imageGallery.button};
    pointer-events: none;
  }

  .modern-image-gallery__controls :global(button) {
    pointer-events: auto;
  }

  /* Element: Main image container */
  .modern-image-gallery__main-image {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .modern-image-gallery {
      flex-direction: column;
      gap: 16px;
      align-items: center;
    }

    .modern-image-gallery__carousel {
      width: 100%;
      max-width: 400px;
      max-height: none;
      order: 2;
    }

    .modern-image-gallery__headline {
      width: 100%;
      max-width: 400px;
      min-height: 350px;
      order: 1;
    }
  }

  @media (max-width: 480px) {
    .modern-image-gallery {
      gap: 12px;
    }

    .modern-image-gallery__carousel {
      max-width: 320px;
    }

    .modern-image-gallery__headline {
      max-width: 320px;
      min-height: 280px;
    }
  }

  /* High contrast support */
  @media (prefers-contrast: high) {
    .modern-image-gallery__carousel {
      border: 1px solid currentColor;
    }
  }

  /* Reduced motion support */
  @media (prefers-reduced-motion: reduce) {
    .modern-image-gallery * {
      transition: none !important;
      animation: none !important;
    }
  }
`;

export { MordenImageGalleryStyles };
